import { Bell } from 'lucide-react'

export default function TermsOfService() {
  return (
    <div className="min-h-screen flex flex-col font-sans text-gray-900">

      {/* ── Nav ── */}
      <header className="sticky top-0 z-50 bg-white border-b border-gray-100">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <a href="/" className="flex items-center gap-2 font-bold text-lg text-gray-900">
            <Bell size={20} className="text-sky-600" />
            <span>Radar Concorsi</span>
          </a>
        </div>
      </header>

      {/* ── Content ── */}
      <main className="flex-1 max-w-3xl mx-auto w-full px-4 sm:px-6 py-12 sm:py-16">
        <h1 className="text-3xl sm:text-4xl font-extrabold mb-2">Termini di Servizio</h1>
        <p className="text-sm text-gray-400 mb-10">Ultimo aggiornamento: aprile 2026</p>

        <Section title="1. Oggetto del servizio">
          <p>
            Radar Concorsi (radarconcorsi.it) è un servizio che monitora il portale inPA
            (portale ufficiale del Governo italiano per i concorsi pubblici) e invia notifiche
            email agli utenti registrati quando vengono pubblicati nuovi bandi corrispondenti
            ai filtri da loro impostati.
          </p>
          <p className="mt-2">
            Il servizio è attualmente disponibile in forma gratuita. Il titolare si riserva
            di introdurre piani a pagamento in futuro, con adeguato preavviso agli utenti.
          </p>
          <p className="mt-2">
            I dati sui concorsi pubblici provengono interamente da inPA. Radar Concorsi non
            garantisce la completezza, l'accuratezza o la tempestività delle informazioni
            pubblicate su inPA, né si assume responsabilità per eventuali errori o omissioni
            presenti nei bandi. La fonte di riferimento ufficiale è sempre il portale su
            cui il bando è stato pubblicato.
          </p>
        </Section>

        <Section title="2. Accettazione dei termini">
          <p>
            L'utilizzo del servizio implica l'accettazione integrale dei presenti Termini di
            Servizio e della{' '}
            <a href="/privacy" className="text-sky-600 hover:underline">Privacy Policy</a>.
            Se non accetti questi termini, non puoi utilizzare il servizio.
          </p>
          <p className="mt-2">
            In caso di modifiche sostanziali, gli utenti saranno informati via email con
            almeno 14 giorni di preavviso. L'utilizzo continuato del servizio dopo tale
            preavviso costituisce accettazione dei nuovi termini.
          </p>
        </Section>

        <Section title="3. Registrazione e account">
          <ul className="list-disc pl-5 space-y-1">
            <li>È necessario registrarsi con un indirizzo email valido e una password.</li>
            <li>Ogni utente può creare un solo account.</li>
            <li>Sei responsabile della riservatezza delle tue credenziali e di tutte le attività svolte tramite il tuo account.</li>
            <li>Non è consentito condividere le credenziali o consentire a terzi di accedere al proprio account.</li>
            <li>Puoi eliminare il tuo account in qualsiasi momento dalla pagina Impostazioni. Tutti i tuoi dati verranno cancellati entro 30 giorni.</li>
          </ul>
        </Section>

        <Section title="4. Obblighi dell'utente">
          <p>Utilizzando il servizio, l'utente si impegna a:</p>
          <ul className="list-disc pl-5 mt-2 space-y-1">
            <li>Non utilizzare il servizio per finalità illecite o contrarie ai presenti termini.</li>
            <li>Non tentare di accedere in modo non autorizzato ai sistemi del servizio.</li>
            <li>Non effettuare scraping automatizzato, reverse engineering o qualsiasi altra attività che possa compromettere l'integrità o la disponibilità del servizio.</li>
            <li>Non creare account multipli per aggirare i limiti del piano gratuito.</li>
            <li>Fornire informazioni veritiere in fase di registrazione.</li>
          </ul>
          <p className="mt-2">
            Il titolare si riserva il diritto di sospendere o eliminare account che violino
            questi obblighi, senza preavviso.
          </p>
        </Section>

        <Section title="5. Disponibilità del servizio e limitazione di responsabilità">
          <p>
            Il servizio è fornito "così com'è" (<em>as is</em>), senza garanzie di continuità
            o assenza di errori. Il titolare si impegna a garantire la massima disponibilità
            possibile, ma non può escludere interruzioni per manutenzione, guasti tecnici o
            cause di forza maggiore.
          </p>
          <p className="mt-2">Radar Concorsi non è responsabile per:</p>
          <ul className="list-disc pl-5 mt-2 space-y-1">
            <li>Bandi non rilevati a causa di ritardi o errori nel portale inPA.</li>
            <li>Notifiche non recapitate per problemi tecnici del provider email o del client dell'utente.</li>
            <li>Decisioni prese dall'utente sulla base delle informazioni ricevute.</li>
            <li>Danni indiretti, consequenziali o perdite di opportunità derivanti dall'uso o dalla non disponibilità del servizio.</li>
          </ul>
        </Section>

        <Section title="6. Proprietà intellettuale">
          <p>
            Il codice sorgente, il brand, il design e i contenuti originali di Radar Concorsi
            sono di proprietà del titolare e protetti dalle leggi sul diritto d'autore.
            L'utente non acquisisce alcun diritto su di essi.
          </p>
          <p className="mt-2">
            I dati personali dell'utente (email, alert, filtri) rimangono di sua proprietà.
            Puoi esportarli o cancellarli in qualsiasi momento dalla pagina Impostazioni.
          </p>
        </Section>

        <Section title="7. Modifiche al servizio">
          <p>
            Il titolare si riserva il diritto di modificare, sospendere o interrompere il
            servizio in qualsiasi momento. In caso di interruzione definitiva, gli utenti
            saranno avvisati con almeno 30 giorni di preavviso via email.
          </p>
        </Section>

        <Section title="8. Legge applicabile e foro competente">
          <p>
            I presenti Termini di Servizio sono regolati dalla legge italiana. Per qualsiasi
            controversia si applica il foro del consumatore ai sensi del{' '}
            <abbr title="D.Lgs. 206/2005">Codice del Consumo</abbr>.
          </p>
        </Section>

        <Section title="9. Contatti">
          <p>
            Per qualsiasi domanda sui presenti Termini di Servizio, scrivi a{' '}
            <a href="mailto:privacy@radarconcorsi.it" className="text-sky-600 hover:underline">
              privacy@radarconcorsi.it
            </a>.
          </p>
        </Section>
      </main>

      {/* ── Footer ── */}
      <footer className="bg-white border-t border-gray-100 py-8 px-4 sm:px-6">
        <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-gray-400">
          <span>© 2026 Radar Concorsi</span>
          <div className="flex gap-6">
            <a href="/" className="hover:text-gray-600 transition-colors">Home</a>
            <a href="/privacy" className="hover:text-gray-600 transition-colors">Privacy Policy</a>
          </div>
        </div>
      </footer>

    </div>
  )
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="mb-10">
      <h2 className="text-xl font-bold mb-3 text-gray-800">{title}</h2>
      <div className="text-gray-600 leading-relaxed">{children}</div>
    </section>
  )
}
